const getters = {
  dzhToken: state => state.app.dzhToken,
}
export default getters
